import * as Yup from "yup";

const MIN_NAME_LENGTH: number = 3;
const MAX_NAME_LENGTH: number = 80;
const MIN_DESCRIPTION_LENGTH: number = 3;
const MAX_DESCRIPTION_LENGTH: number = 250;

const AddEmpowerMeBundleCategoryValidator = Yup.object({
    name : Yup.string()
        .required("Name is Required")
        .min(
            MIN_NAME_LENGTH,
            `Name must be at least ${MIN_NAME_LENGTH} characters long`
        )
        .max(
            MAX_NAME_LENGTH,
            `Name must be less than ${MAX_NAME_LENGTH} characters long`
        ),
    description : Yup.string()
        .required("Description is required")
        .min(
            MIN_DESCRIPTION_LENGTH,
            `Description text must be at least ${MIN_DESCRIPTION_LENGTH} characters long`
        )
        .max(
            MAX_DESCRIPTION_LENGTH,
            `Description text must be less than ${MAX_DESCRIPTION_LENGTH} characters long`
        ),
    status_raw : Yup.string()
        .oneOf(["true", "false"], "Invalid status")
        .required("Status is required"),
    image_raw : Yup.string()
        .test(
            "is-level-one",
            "Image is Required",
            function (value) {
                const { level } = this.parent; // Access date from the parent object (the entire form)
                return (level === 1 && (value !== "" && value !== undefined)) || level === 2;
            }
        )
        .test(
            "is-jpg",
            "Image must be a valid jpg/jpeg,png,webp and svg image file",
            function (value) {

                if (!value) return true; 
                value = value.toLowerCase();

                const validExtensions = [".jpg", ".jpeg", ".png", ".gif", ".webp", ".svg"];
                // Check if the file has a valid extension
                const isValid = validExtensions.some(extension => value.endsWith(extension));
                return isValid;
            }
        )

});

export default AddEmpowerMeBundleCategoryValidator;